import { BaseService } from './../base'
export class IndicatorUserService extends BaseService {
    static get entity () {
        return 'indicator_user'
    }
    static get name () {
        return 'indicator_user'
    }
}